
import { IDs } from '../../helpers/IDs';
import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { getCustomFormConfigEED } from '../dateneingabe/custom/getCustomFormConfigEED';
import { WActionButton } from '../../core/elements/WActionButton';
import { Document, Page, pdf, Text, View } from '@react-pdf/renderer';

interface ZusatzToolsModulEEDProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface ZusatzToolsModulEEDState {
    verbrauch: number;
    verbrauchStufe: number;
}

export class ZusatzToolsModulEED extends React.Component<ZusatzToolsModulEEDProps, ZusatzToolsModulEEDState> {

    constructor(props: any) {
        super(props);
        this.state = {
            verbrauch: undefined,
            verbrauchStufe: undefined
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.checkVerbrauch();
    }

    componentDidUpdate(prevProps: Readonly<ZusatzToolsModulEEDProps>, prevState: Readonly<ZusatzToolsModulEEDState>, snapshot?: any): void {
        this.checkVerbrauch();
    }

    checkVerbrauch() {
        const kennzahlen = this.props.data[IDs.KENNZIFFERN_BERECHNET];
        const verbrauch = getMittelwertEnergieverbrauchLetzt3Jahre(kennzahlen);
        const verbrauchStufe = getVerbrauchStufe(kennzahlen);
        if (this.state.verbrauch !== verbrauch) {
            this.setState({ verbrauch });
        }
        if (this.state.verbrauchStufe !== verbrauchStufe) {
            this.setState({ verbrauchStufe });
        }
    }

    render(): JSX.Element {
        const { verbrauch, verbrauchStufe } = this.state;
        const dataRow = (this.props.data[IDs.ENT_EED_UMFRAGE] || [])[0] || {};
        const customFormConfig = getCustomFormConfigEED(IDs.ENT_EED_UMFRAGE, dataRow, this.props.data);

        if (verbrauchStufe === 0) {
            return (
                <div style={{ padding: 10, fontSize: 12 }}>
                    Dieses Modul ist für Sie irrelevant, da Ihr durchschnittlicher Endenergieverbrauch in den letzten 3 Jahren unter 10 TJ liegt.
                </div>
            );
        }

        return (
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                <div
                    style={{
                        position: 'relative', padding: '0 30px', marginBottom: -15, zIndex: 1,
                        backgroundColor: 'var(--color-wform-background)'
                    }}
                >
                    {this.renderPdfButton(dataRow)}
                </div>
                <WFormsTableWrapper
                    refreshStamp={new Date().getTime()}
                    key={`eed_umfrage_${dataRow.tid}_${this.state.verbrauchStufe}`}
                    formSelectOptionAsRadio={true}
                    entity={IDs.ENT_EED_UMFRAGE}
                    module={IDs.MOD_ETOOL}
                    directEditFormularOf={{
                        tid: dataRow.tid || 0,
                        verbrauch
                    }}
                    inlineFormular={true}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    formLayout2='assistent'
                    formAutoSave={true}
                    formAutoSaveDisableOnUnmount={true}
                    formTitel={'EED Umfrage'}
                    customCssStyle={{
                        // formcontainer: { maxWidth: 600 }
                    }}
                    customFormConfig={customFormConfig}
                    onSaveDone={() => {
                        this.triggerService.fire('reload', IDs.ENT_EED_UMFRAGE);
                    }}
                    globalData={this.props.data}
                />
            </div>
        );
    }

    renderPdfButton(dataRow: any): JSX.Element {
        return (
            <WActionButton
                label='PDF erstellen'
                insideText='PDF erstellen'
                key='pdf'
                action='pdf'
                styleProps={{
                    padding: '1px 8px', whiteSpace: 'nowrap',
                    position: 'absolute', right: 30, top: 10
                }}
                onAction={() => {
                    alert('Funktionen in Entwicklung');
                    this.renderPdf();
                }}
            />
        );
    }

    async makePdf(pdfData: JSX.Element): Promise<void> {
        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            const filename: string = 'EED_Umfrage.pdf';
            saveAs(pdfString, filename);
        } catch (error) {
            console.error(error);
        }
    }

    async renderPdf(): Promise<void> {
        this.makePdf(
            <Document>
                <Page size='A4' orientation='portrait'>
                    {/* {this.renderHeader()} */}
                    <View
                        style={{ paddingLeft: 20 }}
                    >

                    </View>
                    {/* {this.renderFooter()} */}
                </Page>
            </Document>
        );
    }
}

export function getVerbrauchStufe(kennzahlen: Array<any>) {
    const verbrauch = getMittelwertEnergieverbrauchLetzt3Jahre(kennzahlen);
    const tj10 = 2777778; // 10 TJ = 277778 kWh;
    const tj85 = 23611111; // 85 TJ = 23611111 kWh;
    if (verbrauch >= tj85) {
        return 2;
    } else if (verbrauch < tj85 && verbrauch >= tj10) {
        return 1;
    }
    return 0;
}

export function getMittelwertEnergieverbrauchLetzt3Jahre(kennzahlen: Array<any>) {
    const currentYear = new Date().getFullYear();
    let gesamtverbrauch = 0;
    for (let i = 1; i <= 3; i++) {
        const jahr = currentYear - i;
        if (kennzahlen[jahr] && kennzahlen[jahr].gesamtverbrauch > 0) {
            gesamtverbrauch += kennzahlen[jahr].gesamtverbrauch;
        }
    }
    return Math.round(gesamtverbrauch / 3);
}
